import { FieldType, FormNode, FormOpenMode } from '@msdk/definitions'
import { styled, THEME_CONST } from '@msdk/ui'
import React, { ReactElement } from 'react'

import {
  AttachmentField,
  CustomField,
  DateTimeField,
  DateTimeFieldUnknown,
  ListFields,
  LookupField,
  MultiselectorField,
  NumericField,
  OptionsetField,
  StringField,
} from '../Fields'
import { MetadataSelector } from '../Fields/MetadataSelector'
import { TimeField } from '../Fields/TimeField'

interface Props {
  type: FieldType
  node: FormNode
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyOnChange = () => {}
const defaultArgs = { formOpenMode: FormOpenMode.Readonly }

const Container = styled('div')`
  padding: 0;
  .readonly-custom-field {
    margin-right: ${THEME_CONST.defaultPadding}px;
  }
  .MuiFormHelperText-root {
    margin-top: 0;
  }
`

export function ConditionalReadonlyFieldRenderer(props: Props) {
  const renderer: Record<FieldType, ReactElement> = {
    Attachment: <AttachmentField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    Bag: <span>👻</span>,
    Custom: <CustomField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    DateTime: <DateTimeField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    DateTimeUnknown: <DateTimeFieldUnknown onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    Duration: <span>👻</span>,
    Image: <AttachmentField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    List: <ListFields onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    Lookup: <LookupField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    Numeric: <NumericField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    OptionSet: <OptionsetField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    String: <StringField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    MultiSelector: <MultiselectorField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    MetadataSelector: <MetadataSelector onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    Time: <TimeField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    AnyOf: <StringField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
    CodeableConcept: <StringField onChange={emptyOnChange} node={props.node} fieldArgs={defaultArgs} />,
  }

  return (
    <Container className="ConditionalField-renderer readonly">
      {props.node.value.visibility !== 'Invisible' && renderer[props.type]}
    </Container>
  )
}
